<template>
    <v-dialog v-model="dialog_alert" width="1366" persistent>
        <v-card>
            <v-toolbar class="secondary" dark>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Alerts
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-tabs height="47" color="teal" grow v-model="nav">
                    <v-tab slider-color="secondary">
                        <v-icon>mdi-shield-star</v-icon>
                        Badges Expire
                    </v-tab>
                    <v-tab slider-color="secondary">
                        <v-icon>mdi-shield-star</v-icon>
                        Orientation Expire
                    </v-tab>
                    <v-tab>
                        <v-icon>mdi-account-credit-card</v-icon>
                        Credentials
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="nav">
                    <v-tab-item>
                        <v-data-table :headers="headers" :items="badge" :search="search">
                            <template v-slot:top>
                                <v-row>
                                    <v-col cols="4">
                                        <v-text-field label="Search" v-model="search"></v-text-field>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                    <v-tab-item>
                        <v-data-table :headers="headers" :items="orientation" :search="search">
                            <template v-slot:top>
                                <v-row>
                                    <v-col cols="4">
                                        <v-text-field label="Search" v-model="search"></v-text-field>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                    <v-tab-item>
                        <v-data-table :headers="headersCredentials" :items="credentails" :search="search">
                            <template v-slot:top>
                                <v-row>
                                    <v-col cols="4">
                                        <v-text-field label="Search" v-model="search"></v-text-field>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                </v-tabs-items>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
// import axios from 'axios';
// import moment from 'moment';
export default {
    props: ['alerts', 'dialog_alert'],
    data: function () {
        return {
            nav: 0,
            orientation: [],
            credentails: [],
            badge: [],
            search: '',
            headers: [
                { text: 'Driver', value: 'Driver' },
                { text: 'Terminal', value: 'TerminalName' },
                { text: 'Type', value: 'Type' },
                { text: 'ExpireDate', value: 'ExpireDate' },
                { text: 'CountDays', value: 'CountDays' },
            ],

            headersCredentials: [
                { text: 'Driver', value: 'Driver' },
                { text: 'CredType', value: 'CredType' },
                { text: 'ExpireDate', value: 'ExpireDate' },
                { text: 'CountDays', value: 'CountDays' },
            ],
        }
    },
    mounted() {
        console.log(this.alerts);
        this.badge = this.alerts['badge'];
        this.orientation = this.alerts['orientation'];
        this.credentails = this.alerts['credentail'];
    },
    methods: {
    }
}
</script>